import { CUSTOMER_JOURNEY_NEWS_CATEGORY, CUSTOMER_JOURNEY_NEWS_CATEGORY_SUCCESS, CUSTOMER_JOURNEY_NEWS_CATEGORY_ERROR } from '../../actions/const';
import { SET_TOKEN, SET_LANG } from '../../actions/const';

import CustomerJourneySource from '../../sources/CustomerJourneySource';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  apiData: [],
  loading: false,
  catId: null
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_NEWS_CATEGORY: {
      const { catId, token, lang, context, offset, limit } = action
      nextState.loading = true;
      nextState.apiData = [];
      nextState.catId = catId;
      CustomerJourneySource.newsCategory(catId, token, lang, context, offset, limit);
      return nextState;
    }
    case CUSTOMER_JOURNEY_NEWS_CATEGORY_SUCCESS: {
      const { data } = action
      nextState.loading = false;
      nextState.apiData = data;
      return nextState;
    }
    case CUSTOMER_JOURNEY_NEWS_CATEGORY_ERROR: {
      nextState.loading = false;
      nextState.apiData = [];
      return nextState;
    }
    case SET_TOKEN:
    case SET_LANG: {
      if(!isEmpty(state.apiData)) {
        const { token, lang, context, offset, limit } = action
        nextState.loading = true;
        nextState.apiData = [];
        CustomerJourneySource.newsCategory(nextState.catId, token, lang, context, offset, limit);
        return nextState;
      }
      else {
        return state;
      }
    }
    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/newsCategory.js